import { useForm } from "@/shared/libs/react-hook-form";

import { Form, FormItem } from "@/shared/components/Form";
import { Button, InputGroup } from "@blueprintjs/core";
import { z } from "zod";
import React, { useState } from "react";
import {Suggest} from "@/components";

const headerFormSchema = z.object({
  /*title: z.string().optional(), // 编码*/
  content: z.string().optional(), // 客户名称
  notificationType: z.string().optional(), // 通知类型
  priority: z.string().optional(), // 通知级别
  sn:z.string().optional(),
  confirmStatus:z.number().optional(),
  readStatus:z.string().optional()
});

export type HeaderFormDTO = z.infer<typeof headerFormSchema>;

interface HeaderFormProps {
  /** 必传字段，涉及到 Popover 相关的内容，在视图离开当前页需要销毁DOM，不然会引发循环嵌套 */
  showForm: boolean;
  defaultValue?: HeaderFormDTO;
  onChange?: (value: HeaderFormDTO) => void;
  onCreate?: () => void;
}
export const HeaderForm = ({
  showForm,
  defaultValue,
  onChange,
  onCreate,
}: HeaderFormProps) => {
  const [expand, setExpand] = useState(false);
  const methods = useForm({
    schema: headerFormSchema,
    defaultValues: defaultValue,
  });

  const handleFormSubmit = (value: HeaderFormDTO) => {
    onChange?.(value);
  };
  const handleReset = () => {
    methods.reset();
    onChange?.({});
  };
  if (!showForm) return null;
  return (
    <Form
      labelNum={4}
      methods={methods}
      onSubmit={handleFormSubmit}
      onReset={handleReset}
      className="flex justify-between w-full"
    >
      <div
        className="flex flex-1 min-w-0 flex-wrap gap-2 children:w-38 !children:mb-0 overflow-hidden"
        style={{ height: expand ? "auto" : 48, minHeight: 48 }}
      >
        {/*<FormItem field="title" label="标题" className="w-24">*/}
        {/*  <InputGroup small placeholder="请输入" />*/}
        {/*</FormItem>*/}
        <FormItem field="sn" label="通知编号" className="w-48">
          <InputGroup small placeholder="请输入" />
        </FormItem>
        <FormItem field="content" label="内容" className="w-48">
          <InputGroup small placeholder="请输入" />
        </FormItem>
        <FormItem field="priority">
          <Suggest
              small
              options={[
                { label: "紧急", value: 'URGENT' },
                { label: "高", value: 'HIGH' },
                { label: "中", value: 'MEDIUM' },
                { label: "低", value: 'LOW' },
              ]}
              labelKey="label"
              valueKey="value"
              suffixKey="value"
              placeholder="请选择"
              label="通知级别"
              contentClassName="w-36"
          />
        </FormItem>

        <FormItem field="notificationType">
          <Suggest
              small
              options={[
                { label: "系统通知", value: 'SYSTEM' },
                { label: "任务通知", value: 'TASK' },
                { label: "审批通知", value: 'APPROVAL' },
                { label: "提及通知", value: 'MENTION' },
              ]}
              labelKey="label"
              valueKey="value"
              suffixKey="value"
              placeholder="请选择"
              label="通知类型"
              contentClassName="w-36"
          />
        </FormItem>

        <FormItem field="readStatus">
          <Suggest
              small
              options={[
                { label: "已读", value: 'Y' },
                { label: "未读", value: 'N' },
              ]}
              labelKey="label"
              valueKey="value"
              suffixKey="value"
              placeholder="请选择"
              label="阅读状态"
              contentClassName="w-36"
          />
        </FormItem>

        <FormItem field="confirmStatus">
          <Suggest
              small
              options={[
                { label: "未确认", value: '0' },
                { label: "已确认", value: '1' },
                { label: "忽律", value: '2' },
              ]}
              labelKey="label"
              valueKey="value"
              suffixKey="value"
              placeholder="请选择"
              label="确认状态"
              contentClassName="w-36"
          />
        </FormItem>

      </div>
      <div className="flex justify-end items-end gap-2">
        <Button
          icon={expand ? "double-chevron-up" : "double-chevron-down"}
          onClick={setExpand.bind(this, !expand)}
          minimal
        />
        <Button icon="reset" type="reset">
          重置
        </Button>
        <Button intent="primary" icon="search" type="submit">
          查询
        </Button>

      </div>
    </Form>
  );
};
